// src/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { Menu, X } from "lucide-react";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  // const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/"; // 🔥 Check active route

  // const menuLinks = [
  //   { name: "Home", path: "/" },
  //   { name: "About", path: "/about" },
  //   { name: "Service", path: "/services" },
  //   { name: "Products", path: "/product" },
  //   { name: "Contact", path: "/contact" },
  // ];

  useEffect(() => {
    const handleScroll = () => {
      if (isHome) {
        setScrolled(window.scrollY > 50);
      } else {
        setScrolled(true); // other pages always scrolled look
      }
    };

    handleScroll(); // run on first load

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  // const handleLinkClick = () => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  //   navigate("/contact");
  //   setMenuOpen(false);
  // };

  return (
    <nav
      className={`fixed w-full z-30 flex justify-between items-center py-4 px-6 md:px-12 lg:px-20 transition-all duration-300
        ${
          isHome
            ? scrolled
              ? "bg-white shadow-md text-black"
              : "bg-transparent text-white"
            : "bg-white shadow-md text-black"
        }
      `}
    >
      {/* Logo */}
      <div className="flex items-center space-x-2">
        <img
          src={logo}
          alt="Riff Raff Tech Solutions Logo"
          className={`w-32 transition-all duration-300 ${
            isHome
              ? scrolled
                ? "filter brightness-0"
                : "filter brightness-0 invert"
              : "filter brightness-0"
          }`}
        />
      </div>

      {/* Desktop Menu */}
      {/* <div className="hidden lg:flex space-x-10 font-medium">
        {menuLinks.map((link) => (
          <Link
            key={link.name}
            to={link.path}
            className={`transition duration-300 ${
              isHome
                ? scrolled
                  ? "text-gray-800 hover:text-lime-500"
                  : "text-gray-200 hover:text-lime-300"
                : "text-gray-800 hover:text-lime-500"
            }`}
          >
            {link.name}
          </Link>
        ))}
      </div> */}

      {/* Contact Button */}
      <div className="block">
        <a href="/#contact">
          <button
            className={`px-5 py-2 rounded-lg font-medium border transition duration-300 ${
              isHome
                ? scrolled
                  ? "border-black text-black hover:bg-black hover:text-white"
                  : "border-white text-white hover:bg-black hover:text-white"
                : "border-black text-black hover:bg-black hover:text-white"
            }`}
          >
            Let’s Talk
          </button>
        </a>
      </div>

      {/* Mobile Menu Icon */}
      {/* <div className="lg:hidden flex items-center">
        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={() => setMenuOpen(!menuOpen)}
          className="focus:outline-none"
        >
          {menuOpen ? (
            <X
              className={`w-7 h-7 ${scrolled ? "text-gray-800" : "text-white"}`}
            />
          ) : (
            <Menu
              className={`w-7 h-7 ${scrolled ? "text-gray-800" : "text-white"}`}
            />
          )}
        </motion.button>
      </div> */}

      {/* Mobile Dropdown */}
      {/* <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="absolute top-full left-0 w-full bg-white shadow-lg lg:hidden"
          >
            <div className="flex flex-col items-center space-y-6 py-8 font-medium text-gray-800">
              {menuLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  onClick={() => setMenuOpen(false)}
                  className="hover:text-lime-500 transition"
                >
                  {link.name}
                </Link>
              ))}
              <button
                onClick={handleLinkClick}
                className="mt-4 px-6 py-2 border border-black rounded-lg hover:border-lime-500 hover:text-lime-500 transition"
              >
                Let’s Talk
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence> */}
    </nav>
  );
};

export default Navbar;
